import { Box, Image } from '@mantine/core';

interface ManifestusLogoProps {
  h?: number;
  variant?: 'default' | 'dimmed';
  onClick?: () => void;
}

const LOGO_ASPECT = 135.1 / 16.4;

export function ManifestusLogo({
  h = 30,
  variant = 'default',
  onClick,
}: ManifestusLogoProps) {
  const dimmed = variant === 'dimmed';

  return (
    <Box
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        maxWidth: '100%',
        cursor: onClick ? 'pointer' : undefined,
      }}
      onClick={onClick}
    >
      <Image
        src="/logo.svg"
        alt="Manifestus"
        h={h}
        w={Math.round(h * LOGO_ASPECT)}
        fit="contain"
        style={{
          opacity: dimmed ? 0.4 : 1,
          maxWidth: '100%',
          height: 'auto',
          maxHeight: h,
        }}
      />
    </Box>
  );
}
